<template>
    <component :is="tileComponent" class="layout-tile" :class="tileClasses" :to="route" :href="url">
        <div class="flex min-w-0 gap-x-4">
            <image-tile v-if="image" :image="image"></image-tile>
            <div class="flex flex-col" :class="heading && excerpt ? 'justify-around' : ''">
                <content-subheading v-if="heading" :heading="heading" headingComponent="h2"></content-subheading>
                <content-text v-if="excerpt" :html="excerpt"></content-text>
            </div>
        </div>
        <!-- Actions Go Here -->
    </component>
</template>

<script>
export default {
    name: 'LayoutTile',
    props: {
        url: {
            required: false,
            type: String,
            default: null,
        },
        route: {
            required: false,
            type: [String, Object],
            default: null,
        },
        color: {
            required: false,
            type: String,
            default: 'bg-white hover:bg-zinc-50',
        },
        heading: {
            required: false,
            type: String,
            default: null,
        },
        excerpt: {
            required: false,
            type: String,
            default: null,
        },
        image: {
            required: false,
            type: String,
            default: null,
        },
        imageAlt: {
            required: false,
            type: String,
            default: '',
        },
    },
    computed: {
        tileComponent() {
            if (this.route) return 'nuxt-link';
            if (this.url) return 'a';
            return 'div';
        },
        tileClasses() {
            const cls = {};
            cls['flex justify-between gap-x-6 p-4'] = true;
            cls[this.color] = true;
            return cls;
        },
    },
};
</script>
